import { c as _c } from "react/compiler-runtime";
import { Box, Grid } from "@mui-wrapper";
// Here we do not need it as a React component because will be used as src for an image
import groupThumbnail2 from "@assets/thumbnails/groups-thumbs/group-thumbnail_2.svg";
import groupThumbnail3 from "@assets/thumbnails/groups-thumbs/group-thumbnail_3.svg";
import groupThumbnail4 from "@assets/thumbnails/groups-thumbs/group-thumbnail_4.svg";
import groupThumbnail5 from "@assets/thumbnails/groups-thumbs/group-thumbnail_5.svg";
import groupThumbnail6 from "@assets/thumbnails/groups-thumbs/group-thumbnail_6.svg";
import groupThumbnail1 from "@assets/thumbnails/groups-thumbs/group-thumbnail_default.svg";
import projectThumbnail2 from "@assets/thumbnails/project-thumbs/project-thumbnail_2.svg";
import projectThumbnail3 from "@assets/thumbnails/project-thumbs/project-thumbnail_3.svg";
import projectThumbnail4 from "@assets/thumbnails/project-thumbs/project-thumbnail_4.svg";
import projectThumbnail5 from "@assets/thumbnails/project-thumbs/project-thumbnail_5.svg";
import projectThumbnail1 from "@assets/thumbnails/project-thumbs/project-thumbnail_default.svg";
import { Checkmark2Icon } from "@flat-ui";
import { ThumbnailSubjectType } from "@utils/thumbnail-utils";
import { PALETTE_VARS } from "@styles/palette-vars";
/** List of default thumbnail images for group */
const groupThumbnails = [groupThumbnail1, groupThumbnail2, groupThumbnail3, groupThumbnail4, groupThumbnail5, groupThumbnail6];

/** List of default thumbnail images for project */
const projectThumbnails = [projectThumbnail1, projectThumbnail2, projectThumbnail3, projectThumbnail4, projectThumbnail5];

/** Map of thumbnails based on the subject type */
const thumbnailsMap = {
  [ThumbnailSubjectType.project]: projectThumbnails,
  [ThumbnailSubjectType.group]: groupThumbnails
};

/**
 * Renders the thumbnail gallery tab content for a given subject type.
 *
 * @param {Props} props - The component properties, including subject type, selected thumbnail, and callback function.
 *
 * @returns {JSX.Element} A grid of selectable thumbnails based on the specified subject type
 */
export function FaroThumbnailSelector(t0) {
  const $ = _c(12);
  const {
    subjectType,
    selectedThumbnail,
    onSelectImage
  } = t0;
  const thumbnails = thumbnailsMap[subjectType];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      marginTop: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSelectImage || $[2] !== selectedThumbnail || $[3] !== subjectType || $[4] !== thumbnails) {
    let t3;
    if ($[6] !== onSelectImage || $[7] !== selectedThumbnail || $[8] !== subjectType) {
      t3 = thumbnail => {
        const isSelected = selectedThumbnail === thumbnail;
        return <Grid key={thumbnail} component="div" size={{
          xs: 6,
          sm: 4,
          md: 4,
          lg: 4,
          xl: 4
        }} sx={{
          position: "relative"
        }}><Box component="img" src={thumbnail} alt={`${subjectType} thumbnail`} onClick={() => onSelectImage(thumbnail)} sx={{
            width: "100%",
            height: "105px",
            objectFit: "contain",
            borderRadius: "8px",
            padding: "5px",
            cursor: "pointer",
            border: isSelected ? `2px solid ${PALETTE_VARS.primary.main}` : `1px solid ${PALETTE_VARS.divider}`,
            "&:hover": {
              border: `2px solid ${PALETTE_VARS.primary.main}`
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }} />{isSelected && <Checkmark2Icon sx={{
            fill: PALETTE_VARS.primary.main,
            height: "32px",
            width: "32px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }} />}</Grid>;
      };
      $[6] = onSelectImage;
      $[7] = selectedThumbnail;
      $[8] = subjectType;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = thumbnails.map(t3);
    $[1] = onSelectImage;
    $[2] = selectedThumbnail;
    $[3] = subjectType;
    $[4] = thumbnails;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <Grid container={true} spacing={1.5} sx={t1}>{t2}</Grid>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}